import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var eventList = {};
var $on = function $on(eventName, callback) {
  // console.log('$on eventName', eventName)
  if (!eventList[eventName]) {
    eventList[eventName] = [];
  }
  eventList[eventName].push(callback);
};
var $emit = function $emit(eventName, params) {
  console.log('$emit eventName', eventName);
  if (eventList[eventName]) {
    var arr = eventList[eventName];
    arr.forEach(function (cb) {
      cb(params);
    });
  }
};
var $off = function $off(eventName, callback) {
  if (eventList[eventName]) {
    if (callback) {
      var index = eventList[eventName].indexOf(callback);
      eventList[eventName].splice(index, 1);
    } else {
      eventList[eventName].length = 0;
    }
  }
};
export default {
  $on: $on,
  $emit: $emit,
  $off: $off
};